import Svg1 from "../V1/Switch/Accessories/Svg1";
import Svg2 from "../V1/Switch/Accessories/Svg2";
import Svg3 from "../V1/Switch/Accessories/Svg3";
import Svg4 from "../V1/Switch/Accessories/Svg4";
import Svg5 from "../V1/Switch/Accessories/Svg5";
import Svg6 from "../V1/Switch/Accessories/Svg6";
import Svg7 from "../V1/Switch/Accessories/Svg7";
import Svg8 from "../V1/Switch/Accessories/Svg8";
import Svg9 from "../V1/Switch/Accessories/Svg9";
import Svg10 from "../V1/Switch/Accessories/Svg10";
import Svg11 from "../V1/Switch/Accessories/Svg11";
import Svg12 from "../V1/Switch/Accessories/Svg12";
import Svg13 from "../V1/Switch/Accessories/Svg13";
import Svg14 from "../V1/Switch/Accessories/Svg14";

import Svg29 from "../V1/Switch/Lamp/Svg29";
import Svg30 from "../V1/Switch/Lamp/30";
import Svg31 from "../V1/Switch/Lamp/31";
import Svg32 from "../V1/Switch/Lamp/32";
import Svg33 from "../V1/Switch/Lamp/33";
import Svg34 from "../V1/Switch/Lamp/34";
import Svg35 from "../V1/Switch/Lamp/35";
import Svg36 from "../V1/Switch/Lamp/36";
import Svg37 from "../V1/Switch/Lamp/37";
import Svg38 from "../V1/Switch/Lamp/38";
import Svg39 from "../V1/Switch/Lamp/39";
import Svg40 from "../V1/Switch/Lamp/40";
import Svg41 from "../V1/Switch/Lamp/41";
import Svg42 from "../V1/Switch/Lamp/42";
import Svg43 from "../V1/Switch/Lamp/43";
import Svg44 from "../V1/Switch/Lamp/44";
import Svg45 from "../V1/Switch/Lamp/45";
import Svg46 from "../V1/Switch/Lamp/46";
import Svg47 from "../V1/Switch/Lamp/47";
import Svg48 from "../V1/Switch/Lamp/48";
import Svg49 from "../V1/Switch/Lamp/49";
import Svg50 from "../V1/Switch/Lamp/50";
import Svg51 from "../V1/Switch/Lamp/51";
import Svg52 from "../V1/Switch/Lamp/52";
import Svg53 from "../V1/Switch/Lamp/53";
import Svg54 from "../V1/Switch/Lamp/54";
import Svg55 from "../V1/Switch/Lamp/55";
import Svg56 from "../V1/Switch/Lamp/56";

import Svg57 from "../V1/Switch/Lighting/57";
import Svg58 from "../V1/Switch/Lighting/58";
import Svg59 from "../V1/Switch/Lighting/59";
import Svg60 from "../V1/Switch/Lighting/60";
import Svg61 from "../V1/Switch/Lighting/61";
import Svg62 from "../V1/Switch/Lighting/62";
import Svg63 from "../V1/Switch/Lighting/63";
import Svg64 from "../V1/Switch/Lighting/64";
import Svg65 from "../V1/Switch/Lighting/65";
import Svg66 from "../V1/Switch/Lighting/66";
import Svg67 from "../V1/Switch/Lighting/67";
import Svg68 from "../V1/Switch/Lighting/68";
import Svg69 from "../V1/Switch/Lighting/69";
import Svg70 from "../V1/Switch/Lighting/70";
import Svg71 from "../V1/Switch/Lighting/71";
import Svg72 from "../V1/Switch/Lighting/72";
import Svg73 from "../V1/Switch/Lighting/73";
import Svg74 from "../V1/Switch/Lighting/74";
import Svg75 from "../V1/Switch/Lighting/75";
import Svg76 from "../V1/Switch/Lighting/76";
import Svg77 from "../V1/Switch/Lighting/77";
import Svg78 from "../V1/Switch/Lighting/78";
import Svg79 from "../V1/Switch/Lighting/79";
import Svg80 from "../V1/Switch/Lighting/80";
import Svg81 from "../V1/Switch/Lighting/81";
import Svg82 from "../V1/Switch/Lighting/82";
import Svg83 from "../V1/Switch/Lighting/83";
import Svg84 from "../V1/Switch/Lighting/84";
import Svg85 from "../V1/Switch/Lighting/85";
import Svg86 from "../V1/Switch/Lighting/86";
import Svg87 from "../V1/Switch/Lighting/87";
import Svg88 from "../V1/Switch/Lighting/88";
import Svg89 from "../V1/Switch/Lighting/89";
import Svg90 from "../V1/Switch/Lighting/90";
import Svg91 from "../V1/Switch/Lighting/91";
import Svg92 from "../V1/Switch/Lighting/92";
import Svg93 from "../V1/Switch/Lighting/93";
import Svg94 from "../V1/Switch/Lighting/94";
import Svg95 from "../V1/Switch/Lighting/95";
import Svg96 from "../V1/Switch/Lighting/96";
import Svg97 from "../V1/Switch/Lighting/97";
import Svg98 from "../V1/Switch/Lighting/98";
import Svg99 from "../V1/Switch/Lighting/99";
import Svg100 from "../V1/Switch/Lighting/100";
import Svg101 from "../V1/Switch/Lighting/101";
import Svg102 from "../V1/Switch/Lighting/102";
import Svg103 from "../V1/Switch/Lighting/103";
import Svg104 from "../V1/Switch/Lighting/104";
import Svg105 from "../V1/Switch/Lighting/105";
import Svg106 from "../V1/Switch/Lighting/106";
import Svg107 from "../V1/Switch/Lighting/107";
import Svg108 from "../V1/Switch/Lighting/108";
import Svg109 from "../V1/Switch/Lighting/109";
import Svg110 from "../V1/Switch/Lighting/110";
import Svg111 from "../V1/Switch/Lighting/111";
import Svg112 from "../V1/Switch/Lighting/112";
import Svg113 from "../V1/Switch/Lighting/113";
import Svg114 from "../V1/Switch/Lighting/114";
import Svg115 from "../V1/Switch/Lighting/115";
import Svg116 from "../V1/Switch/Lighting/116";
import Svg117 from "../V1/Switch/Lighting/117";
import Svg118 from "../V1/Switch/Lighting/118";
import Svg119 from "../V1/Switch/Lighting/119";
import Svg120 from "../V1/Switch/Lighting/120";
import Svg121 from "../V1/Switch/Lighting/121";
import Svg122 from "../V1/Switch/Lighting/122";
import Svg123 from "../V1/Switch/Lighting/123";
import Svg124 from "../V1/Switch/Lighting/124";
import Svg125 from "../V1/Switch/Lighting/125";
import Svg126 from "../V1/Switch/Lighting/126";
import Svg127 from "../V1/Switch/Lighting/127";
import Svg128 from "../V1/Switch/Lighting/128";
import Svg129 from "../V1/Switch/Lighting/129";
import Svg130 from "../V1/Switch/Lighting/130";
import Svg131 from "../V1/Switch/Lighting/131";
import Svg132 from "../V1/Switch/Lighting/132";
import Svg133 from "../V1/Switch/Lighting/133";
import Svg134 from "../V1/Switch/Lighting/134";
import Svg135 from "../V1/Switch/Lighting/135";
import Svg136 from "../V1/Switch/Lighting/136";

import Svg225 from "../V1/Switch/Appliances/225";
import Svg226 from "../V1/Switch/Appliances/226";
import Svg227 from "../V1/Switch/Appliances/227";
import Svg228 from "../V1/Switch/Appliances/228";
import Svg229 from "../V1/Switch/Appliances/229";
import Svg230 from "../V1/Switch/Appliances/230";
import Svg231 from "../V1/Switch/Appliances/231";
import Svg232 from "../V1/Switch/Appliances/232";
import Svg233 from "../V1/Switch/Appliances/233";
import Svg234 from "../V1/Switch/Appliances/234";
import Svg235 from "../V1/Switch/Appliances/235";
import Svg236 from "../V1/Switch/Appliances/236";
import Svg237 from "../V1/Switch/Appliances/237";
import Svg238 from "../V1/Switch/Appliances/238";
import Svg239 from "../V1/Switch/Appliances/239";
import Svg240 from "../V1/Switch/Appliances/240";
import Svg241 from "../V1/Switch/Appliances/241";
import Svg242 from "../V1/Switch/Appliances/242";
import Svg243 from "../V1/Switch/Appliances/243";
import Svg244 from "../V1/Switch/Appliances/244";
import Svg245 from "../V1/Switch/Appliances/245";
import Svg246 from "../V1/Switch/Appliances/246";
import Svg247 from "../V1/Switch/Appliances/247";
import Svg248 from "../V1/Switch/Appliances/248";
import Svg249 from "../V1/Switch/Appliances/249";
import Svg250 from "../V1/Switch/Appliances/250";
import Svg251 from "../V1/Switch/Appliances/251";
import Svg252 from "../V1/Switch/Appliances/252";
import Svg253 from "../V1/Switch/Appliances/253";
import Svg254 from "../V1/Switch/Appliances/254";
import Svg255 from "../V1/Switch/Appliances/255";
import Svg256 from "../V1/Switch/Appliances/256";
import Svg257 from "../V1/Switch/Appliances/257";
import Svg258 from "../V1/Switch/Appliances/258";
import Svg259 from "../V1/Switch/Appliances/259";
import Svg260 from "../V1/Switch/Appliances/260";
import Svg261 from "../V1/Switch/Appliances/261";
import Svg262 from "../V1/Switch/Appliances/262";
import Svg263 from "../V1/Switch/Appliances/263";
import Svg264 from "../V1/Switch/Appliances/264";
import Svg265 from "../V1/Switch/Appliances/265";
import Svg266 from "../V1/Switch/Appliances/266";
import Svg267 from "../V1/Switch/Appliances/267";
import Svg268 from "../V1/Switch/Appliances/268";
import Svg269 from "../V1/Switch/Appliances/269";
import Svg270 from "../V1/Switch/Appliances/270";
import Svg271 from "../V1/Switch/Appliances/271";
import Svg272 from "../V1/Switch/Appliances/272";
import Svg273 from "../V1/Switch/Appliances/273";
import Svg274 from "../V1/Switch/Appliances/274";
import Svg275 from "../V1/Switch/Appliances/275";
import Svg276 from "../V1/Switch/Appliances/276";
import Svg277 from "../V1/Switch/Appliances/277";
import Svg278 from "../V1/Switch/Appliances/278";
import Svg279 from "../V1/Switch/Appliances/279";
import Svg280 from "../V1/Switch/Appliances/280";
import Svg281 from "../V1/Switch/Appliances/281";
import Svg282 from "../V1/Switch/Appliances/282";
import Svg283 from "../V1/Switch/Appliances/283";
import Svg284 from "../V1/Switch/Appliances/284";
import Svg285 from "../V1/Switch/Appliances/285";

import Svg309 from "../V1/Switch/Scene/309";
import Svg310 from "../V1/Switch/Scene/310";
import Svg311 from "../V1/Switch/Scene/311";
import Svg312 from "../V1/Switch/Scene/312";
import Svg313 from "../V1/Switch/Scene/313";
import Svg314 from "../V1/Switch/Scene/314";
import Svg315 from "../V1/Switch/Scene/315";
import Svg316 from "../V1/Switch/Scene/316";
import Svg317 from "../V1/Switch/Scene/317";
import Svg318 from "../V1/Switch/Scene/318";
import Svg319 from "../V1/Switch/Scene/319";
import Svg320 from "../V1/Switch/Scene/320";
import Svg321 from "../V1/Switch/Scene/321";
import Svg322 from "../V1/Switch/Scene/322";
import Svg323 from "../V1/Switch/Scene/323";
import Svg324 from "../V1/Switch/Scene/324";
import Svg325 from "../V1/Switch/Scene/325";
import Svg326 from "../V1/Switch/Scene/326";
import Svg327 from "../V1/Switch/Scene/327";
import Svg328 from "../V1/Switch/Scene/328";
import Svg329 from "../V1/Switch/Scene/329";
import Svg330 from "../V1/Switch/Scene/330";
import Svg331 from "../V1/Switch/Scene/331";
import Svg332 from "../V1/Switch/Scene/332";
import Svg333 from "../V1/Switch/Scene/333";
import Svg334 from "../V1/Switch/Scene/334";
import Svg335 from "../V1/Switch/Scene/335";
import Svg336 from "../V1/Switch/Scene/336";
// import Svg337 from "../V1/Switch/Scene/337";
import Svg338 from "../V1/Switch/Scene/338";
import Svg339 from "../V1/Switch/Scene/339";
import Svg340 from "../V1/Switch/Scene/340";
import Svg341 from "../V1/Switch/Scene/341";
import Svg342 from "../V1/Switch/Scene/342";
import Svg343 from "../V1/Switch/Scene/343";
import Svg344 from "../V1/Switch/Scene/344";
import Svg345 from "../V1/Switch/Scene/345";
import Svg346 from "../V1/Switch/Scene/346";
import Svg347 from "../V1/Switch/Scene/347";
import Svg348 from "../V1/Switch/Scene/348";
import Svg349 from "../V1/Switch/Scene/349";
import Svg350 from "../V1/Switch/Scene/350";
import Svg351 from "../V1/Switch/Scene/351";
import Svg352 from "../V1/Switch/Scene/352";
import Svg353 from "../V1/Switch/Scene/353";
import Svg354 from "../V1/Switch/Scene/354";
import Svg355 from "../V1/Switch/Scene/355";
import Svg356 from "../V1/Switch/Scene/356";
import Svg357 from "../V1/Switch/Scene/357";
import Svg358 from "../V1/Switch/Scene/358";
import Svg359 from "../V1/Switch/Scene/359";
import Svg360 from "../V1/Switch/Scene/360";

import Svg365 from "../V1/Switch/Pattern/365";
import Svg366 from "../V1/Switch/Pattern/366";
import Svg367 from "../V1/Switch/Pattern/367";
import Svg368 from "../V1/Switch/Pattern/368";
import Svg369 from "../V1/Switch/Pattern/369";
import Svg370 from "../V1/Switch/Pattern/370";
import Svg371 from "../V1/Switch/Pattern/371";
import Svg372 from "../V1/Switch/Pattern/372";
import Svg373 from "../V1/Switch/Pattern/373";
import Svg374 from "../V1/Switch/Pattern/374";
import Svg375 from "../V1/Switch/Pattern/375";
import Svg376 from "../V1/Switch/Pattern/376";
import Svg377 from "../V1/Switch/Pattern/377";
import Svg378 from "../V1/Switch/Pattern/378";
import Svg379 from "../V1/Switch/Pattern/379";
import Svg380 from "../V1/Switch/Pattern/380";
import Svg381 from "../V1/Switch/Pattern/381";
import Svg382 from "../V1/Switch/Pattern/382";
import Svg383 from "../V1/Switch/Pattern/383";
import Svg384 from "../V1/Switch/Pattern/384";
import Svg385 from "../V1/Switch/Pattern/385";
import Svg386 from "../V1/Switch/Pattern/386";
import Svg387 from "../V1/Switch/Pattern/387";
import Svg388 from "../V1/Switch/Pattern/388";
import Svg389 from "../V1/Switch/Pattern/389";
import Svg390 from "../V1/Switch/Pattern/390";
import Svg391 from "../V1/Switch/Pattern/391";
import Svg392 from "../V1/Switch/Pattern/392";
import Svg393 from "../V1/Switch/Pattern/393";
import Svg394 from "../V1/Switch/Pattern/394";
import Svg395 from "../V1/Switch/Pattern/395";
import Svg396 from "../V1/Switch/Pattern/396";
import Svg397 from "../V1/Switch/Pattern/397";
import Svg398 from "../V1/Switch/Pattern/398";
import Svg399 from "../V1/Switch/Pattern/399";
import Svg400 from "../V1/Switch/Pattern/400";
import Svg401 from "../V1/Switch/Pattern/401";
import Svg402 from "../V1/Switch/Pattern/402";
import Svg403 from "../V1/Switch/Pattern/403";
import Svg404 from "../V1/Switch/Pattern/404";
import Svg405 from "../V1/Switch/Pattern/405";
import Svg406 from "../V1/Switch/Pattern/406";
import Svg407 from "../V1/Switch/Pattern/407";
import Svg408 from "../V1/Switch/Pattern/408";
import Svg409 from "../V1/Switch/Pattern/409";
import Svg410 from "../V1/Switch/Pattern/410";
import Svg411 from "../V1/Switch/Pattern/411";
import Svg412 from "../V1/Switch/Pattern/412";
import Svg413 from "../V1/Switch/Pattern/413";
import Svg414 from "../V1/Switch/Pattern/414";
import Svg415 from "../V1/Switch/Pattern/415";
import Svg416 from "../V1/Switch/Pattern/416";
import Svg417 from "../V1/Switch/Pattern/417";
import Svg418 from "../V1/Switch/Pattern/418";
import Svg419 from "../V1/Switch/Pattern/419";
import Svg420 from "../V1/Switch/Pattern/420";

import Svg421 from "../V1/Switch/Symbol/421";
import Svg422 from "../V1/Switch/Symbol/422";
import Svg423 from "../V1/Switch/Symbol/423";
import Svg424 from "../V1/Switch/Symbol/424";
import Svg425 from "../V1/Switch/Symbol/425";
import Svg426 from "../V1/Switch/Symbol/426";
import Svg427 from "../V1/Switch/Symbol/427";
import Svg428 from "../V1/Switch/Symbol/428";
import Svg429 from "../V1/Switch/Symbol/429";
import Svg430 from "../V1/Switch/Symbol/430";
import Svg431 from "../V1/Switch/Symbol/431";
import Svg432 from "../V1/Switch/Symbol/432";
import Svg433 from "../V1/Switch/Symbol/433";
import Svg434 from "../V1/Switch/Symbol/434";
import Svg435 from "../V1/Switch/Symbol/435";
import Svg436 from "../V1/Switch/Symbol/436";
import Svg437 from "../V1/Switch/Symbol/437";
import Svg438 from "../V1/Switch/Symbol/438";
import Svg439 from "../V1/Switch/Symbol/439";
import Svg440 from "../V1/Switch/Symbol/440";
import Svg441 from "../V1/Switch/Symbol/441";
import Svg442 from "../V1/Switch/Symbol/442";
import Svg443 from "../V1/Switch/Symbol/443";
import Svg444 from "../V1/Switch/Symbol/444";
import Svg445 from "../V1/Switch/Symbol/445";
import Svg446 from "../V1/Switch/Symbol/446";
import Svg447 from "../V1/Switch/Symbol/447";
import Svg448 from "../V1/Switch/Symbol/448";
import Svg449 from "../V1/Switch/Symbol/449";
import Svg450 from "../V1/Switch/Symbol/450";
import Svg451 from "../V1/Switch/Symbol/451";
import Svg452 from "../V1/Switch/Symbol/452";
import Svg453 from "../V1/Switch/Symbol/453";
import Svg454 from "../V1/Switch/Symbol/454";
import Svg455 from "../V1/Switch/Symbol/455";
import Svg456 from "../V1/Switch/Symbol/456";
import Svg457 from "../V1/Switch/Symbol/457";
import Svg458 from "../V1/Switch/Symbol/458";
import Svg459 from "../V1/Switch/Symbol/459";
import Svg460 from "../V1/Switch/Symbol/460";
import Svg461 from "../V1/Switch/Symbol/461";
import Svg462 from "../V1/Switch/Symbol/462";
import Svg463 from "../V1/Switch/Symbol/463";
import Svg464 from "../V1/Switch/Symbol/464";
import Svg465 from "../V1/Switch/Symbol/465";
import Svg466 from "../V1/Switch/Symbol/466";
import Svg467 from "../V1/Switch/Symbol/467";
import Svg468 from "../V1/Switch/Symbol/468";
import Svg469 from "../V1/Switch/Symbol/469";
import Svg470 from "../V1/Switch/Symbol/470";
import Svg471 from "../V1/Switch/Symbol/471";
import Svg472 from "../V1/Switch/Symbol/472";

import Svg477 from "../V1/Switch/Arrow/477";
import Svg478 from "../V1/Switch/Arrow/478";
import Svg479 from "../V1/Switch/Arrow/479";
import Svg480 from "../V1/Switch/Arrow/480";
import Svg481 from "../V1/Switch/Arrow/481";
import Svg482 from "../V1/Switch/Arrow/482";
import Svg483 from "../V1/Switch/Arrow/483";
import Svg484 from "../V1/Switch/Arrow/484";
import Svg485 from "../V1/Switch/Arrow/485";
import Svg486 from "../V1/Switch/Arrow/486";
import Svg487 from "../V1/Switch/Arrow/487";
import Svg488 from "../V1/Switch/Arrow/488";
import Svg489 from "../V1/Switch/Arrow/489";
import Svg490 from "../V1/Switch/Arrow/490";
import Svg491 from "../V1/Switch/Arrow/491";
import Svg492 from "../V1/Switch/Arrow/492";
import Svg493 from "../V1/Switch/Arrow/493";
import Svg494 from "../V1/Switch/Arrow/494";
import Svg495 from "../V1/Switch/Arrow/495";
import Svg496 from "../V1/Switch/Arrow/496";
import Svg497 from "../V1/Switch/Arrow/497";
import Svg498 from "../V1/Switch/Arrow/498";
import Svg499 from "../V1/Switch/Arrow/499";
import Svg500 from "../V1/Switch/Arrow/500";
import Svg501 from "../V1/Switch/Arrow/501";
import Svg502 from "../V1/Switch/Arrow/502";
import Svg503 from "../V1/Switch/Arrow/503";
import Svg504 from "../V1/Switch/Arrow/504";
import Svg505 from "../V1/Switch/Arrow/505";
import Svg506 from "../V1/Switch/Arrow/506";
import Svg507 from "../V1/Switch/Arrow/507";
import Svg508 from "../V1/Switch/Arrow/508";
import Svg509 from "../V1/Switch/Arrow/509";
import Svg510 from "../V1/Switch/Arrow/510";

import Svg533 from "../V1/Switch/Vehicle/533";
import Svg534 from "../V1/Switch/Vehicle/534";
import Svg535 from "../V1/Switch/Vehicle/535";
import Svg536 from "../V1/Switch/Vehicle/536";
import Svg537 from "../V1/Switch/Vehicle/537";
import Svg538 from "../V1/Switch/Vehicle/538";
import Svg539 from "../V1/Switch/Vehicle/539";
import Svg540 from "../V1/Switch/Vehicle/540";
import Svg541 from "../V1/Switch/Vehicle/541";

import Svg561 from "../V1/Switch/Hospitality/561";
import Svg562 from "../V1/Switch/Hospitality/562";
import Svg563 from "../V1/Switch/Hospitality/563";
import Svg564 from "../V1/Switch/Hospitality/564";
import Svg565 from "../V1/Switch/Hospitality/565";
import Svg566 from "../V1/Switch/Hospitality/566";
import Svg567 from "../V1/Switch/Hospitality/567";
import Svg568 from "../V1/Switch/Hospitality/568";
import Svg569 from "../V1/Switch/Hospitality/569";
import Svg570 from "../V1/Switch/Hospitality/570";
import Svg571 from "../V1/Switch/Hospitality/571";
import Svg589 from "../V1/Switch/Number/589";
import Svg590 from "../V1/Switch/Number/590";
import Svg591 from "../V1/Switch/Number/591";
import Svg592 from "../V1/Switch/Number/592";
import Svg593 from "../V1/Switch/Number/593";
import Svg594 from "../V1/Switch/Number/594";
import Svg595 from "../V1/Switch/Number/595";
import Svg596 from "../V1/Switch/Number/596";
import Svg597 from "../V1/Switch/Number/597";
import Svg598 from "../V1/Switch/Number/598";
import Svg599 from "../V1/Switch/Number/599";
import Svg600 from "../V1/Switch/Number/600";
import Svg601 from "../V1/Switch/Number/601";
import Svg602 from "../V1/Switch/Number/602";
import Svg603 from "../V1/Switch/Number/603";
import Svg604 from "../V1/Switch/Number/604";
import Svg605 from "../V1/Switch/Number/605";
import Svg606 from "../V1/Switch/Number/606";
import Svg607 from "../V1/Switch/Number/607";
import Svg608 from "../V1/Switch/Number/608";

import Svg617 from "../V1/Switch/Alphabet/617";
import Svg618 from "../V1/Switch/Alphabet/618";
import Svg619 from "../V1/Switch/Alphabet/619";
import Svg620 from "../V1/Switch/Alphabet/620";
import Svg621 from "../V1/Switch/Alphabet/621";
import Svg622 from "../V1/Switch/Alphabet/622";
import Svg623 from "../V1/Switch/Alphabet/623";
import Svg624 from "../V1/Switch/Alphabet/624";
import Svg625 from "../V1/Switch/Alphabet/625";
import Svg626 from "../V1/Switch/Alphabet/626";
import Svg627 from "../V1/Switch/Alphabet/627";
import Svg628 from "../V1/Switch/Alphabet/628";
import Svg629 from "../V1/Switch/Alphabet/629";
import Svg630 from "../V1/Switch/Alphabet/630";
import Svg631 from "../V1/Switch/Alphabet/631";
import Svg632 from "../V1/Switch/Alphabet/632";
import Svg633 from "../V1/Switch/Alphabet/633";
import Svg634 from "../V1/Switch/Alphabet/634";
import Svg635 from "../V1/Switch/Alphabet/635";
import Svg636 from "../V1/Switch/Alphabet/636";
import Svg637 from "../V1/Switch/Alphabet/637";
import Svg638 from "../V1/Switch/Alphabet/638";
import Svg639 from "../V1/Switch/Alphabet/639";
import Svg640 from "../V1/Switch/Alphabet/640";
import Svg641 from "../V1/Switch/Alphabet/641";
import Svg642 from "../V1/Switch/Alphabet/642";
import Svg643 from "../V1/Switch/Alphabet/643";
import Svg645 from "../V1/Switch/Pets/645";
import Svg646 from "../V1/Switch/Pets/646";

import Svg673 from "../V1/Master on off/MasterOnOff/673";
import Svg674 from "../V1/Master on off/MasterOnOff/674";
import Svg675 from "../V1/Master on off/MasterOnOff/675";
import Svg676 from "../V1/Master on off/MasterOnOff/676";

import Svg169 from "../V1/Curtain Open/169";
import Svg170 from "../V1/Curtain Open/170";
import Svg171 from "../V1/Curtain Open/171";
import Svg172 from "../V1/Curtain Open/172";
import Svg173 from "../V1/Curtain Open/173";
import Svg174 from "../V1/Curtain Open/174";
import Svg175 from "../V1/Curtain Open/175";
import Svg176 from "../V1/Curtain Open/176";
import Svg177 from "../V1/Curtain Open/177";
import Svg178 from "../V1/Curtain Open/178";
import Svg179 from "../V1/Curtain Open/179";
import Svg180 from "../V1/Curtain Open/180";
import Svg181 from "../V1/Curtain Open/181";
import Svg182 from "../V1/Curtain Open/182";
import Svg183 from "../V1/Curtain Open/183";
import Svg184 from "../V1/Curtain Open/184";
import Svg185 from "../V1/Curtain Open/185";
import Svg186 from "../V1/Curtain Open/186";
import Svg187 from "../V1/Curtain Open/187";
import Svg188 from "../V1/Curtain Open/188";
import Svg189 from "../V1/Curtain Open/189";
import Svg190 from "../V1/Curtain Open/190";
import Svg191 from "../V1/Curtain Open/191";
import Svg192 from "../V1/Curtain Open/192";
import Svg193 from "../V1/Curtain Open/193";
import Svg194 from "../V1/Curtain Open/194";
import Svg195 from "../V1/Curtain Open/195";
import Svg196 from "../V1/Curtain Open/196";

import Svg197 from "../V1/Curtain Close/197";
import Svg198 from "../V1/Curtain Close/198";
import Svg199 from "../V1/Curtain Close/199";
import Svg200 from "../V1/Curtain Close/200";
import Svg201 from "../V1/Curtain Close/201";
import Svg202 from "../V1/Curtain Close/202";
import Svg203 from "../V1/Curtain Close/203";
import Svg204 from "../V1/Curtain Close/204";
import Svg205 from "../V1/Curtain Close/205";
import Svg206 from "../V1/Curtain Close/206";
import Svg207 from "../V1/Curtain Close/207";
import Svg208 from "../V1/Curtain Close/208";
import Svg209 from "../V1/Curtain Close/209";
import Svg210 from "../V1/Curtain Close/210";
import Svg211 from "../V1/Curtain Close/211";
import Svg212 from "../V1/Curtain Close/212";
import Svg213 from "../V1/Curtain Close/213";
import Svg214 from "../V1/Curtain Close/214";
import Svg215 from "../V1/Curtain Close/215";
import Svg216 from "../V1/Curtain Close/216";
import Svg217 from "../V1/Curtain Close/217";
import Svg218 from "../V1/Curtain Close/218";
import Svg219 from "../V1/Curtain Close/219";
import Svg220 from "../V1/Curtain Close/220";
import Svg221 from "../V1/Curtain Close/221";
import Svg222 from "../V1/Curtain Close/222";
import Svg223 from "../V1/Curtain Close/223";
import Svg224 from "../V1/Curtain Close/224";

import Svg141 from "../V1/Switch/4 Fan/141";
import Svg142 from "../V1/Switch/4 Fan/142";
import Svg143 from "../V1/Switch/4 Fan/143";
import Svg144 from "../V1/Switch/4 Fan/144";
import Svg145 from "../V1/Switch/4 Fan/145";
import Svg146 from "../V1/Switch/4 Fan/146";
import Svg147 from "../V1/Switch/4 Fan/147";
import Svg148 from "../V1/Switch/4 Fan/148";
import Svg149 from "../V1/Switch/4 Fan/149";
import Svg150 from "../V1/Switch/4 Fan/150";
import Svg151 from "../V1/Switch/4 Fan/151";
import Svg152 from "../V1/Switch/4 Fan/152";
import Svg153 from "../V1/Switch/4 Fan/153";
import Svg154 from "../V1/Switch/4 Fan/154";
import Svg155 from "../V1/Switch/4 Fan/155";
import Svg156 from "../V1/Switch/4 Fan/156";
import Svg157 from "../V1/Switch/4 Fan/157";
import Svg158 from "../V1/Switch/4 Fan/158";
import Svg159 from "../V1/Switch/4 Fan/159";
import Svg160 from "../V1/Switch/4 Fan/160";
import Svg161 from "../V1/Switch/4 Fan/161";
import Svg162 from "../V1/Switch/4 Fan/162";
import Svg163 from "../V1/Switch/4 Fan/163";
import Svg164 from "../V1/Switch/4 Fan/164";
import Svg165 from "../V1/Switch/4 Fan/165";
import Svg166 from "../V1/Switch/4 Fan/166";
import Svg167 from "../V1/Switch/4 Fan/167";
import Svg168 from "../V1/Switch/4 Fan/168";

import Svg701 from "../V1/Speed Plus/701";
import Svg702 from "../V1/Speed Plus/702";
import Svg703 from "../V1/Speed Plus/703";
import Svg704 from "../V1/Speed Plus/704";
import Svg705 from "../V1/Speed Plus/705";
import Svg706 from "../V1/Speed Plus/706";
import Svg707 from "../V1/Speed Plus/707";
import Svg708 from "../V1/Speed Plus/708";
import Svg709 from "../V1/Speed Plus/709";
import Svg710 from "../V1/Speed Plus/710";
import Svg711 from "../V1/Speed Plus/711";
import Svg712 from "../V1/Speed Plus/712";
import Svg713 from "../V1/Speed Plus/713";
import Svg714 from "../V1/Speed Plus/714";
import Svg715 from "../V1/Speed Plus/715";
import Svg716 from "../V1/Speed Plus/716";
import Svg717 from "../V1/Speed Plus/717";
import Svg718 from "../V1/Speed Plus/718";
import Svg719 from "../V1/Speed Plus/719";
import Svg720 from "../V1/Speed Plus/720";

import Svg729 from "../V1/Speed Minus/729";
import Svg730 from "../V1/Speed Minus/730";
import Svg731 from "../V1/Speed Minus/731";
import Svg732 from "../V1/Speed Minus/732";
import Svg733 from "../V1/Speed Minus/733";
import Svg734 from "../V1/Speed Minus/734";
import Svg735 from "../V1/Speed Minus/735";
import Svg736 from "../V1/Speed Minus/736";
import Svg737 from "../V1/Speed Minus/737";
import Svg738 from "../V1/Speed Minus/738";
import Svg739 from "../V1/Speed Minus/739";
import Svg740 from "../V1/Speed Minus/740";
import Svg741 from "../V1/Speed Minus/741";
import Svg742 from "../V1/Speed Minus/742";
import Svg743 from "../V1/Speed Minus/743";
import Svg744 from "../V1/Speed Minus/744";
import Svg745 from "../V1/Speed Minus/745";
import Svg746 from "../V1/Speed Minus/746";
import Svg747 from "../V1/Speed Minus/747";
import Svg748 from "../V1/Speed Minus/748";

const fanMinusIcons = [
  Svg729,
  Svg730,
  Svg731,
  Svg732,
  Svg733,
  Svg734,
  Svg735,
  Svg736,
  Svg737,
  Svg738,
  Svg739,
  Svg740,
  Svg741,
  Svg742,
  Svg743,
  Svg744,
  Svg745,
  Svg746,
  Svg747,
  Svg748,
];

const fanSelectedMinusIcons = [Svg735, Svg742, Svg746, Svg747];

const fanPlusIcons = [
  Svg701,
  Svg702,
  Svg703,
  Svg704,
  Svg705,
  Svg706,
  Svg707,
  Svg708,
  Svg709,
  Svg710,
  Svg711,
  Svg712,
  Svg713,
  Svg714,
  Svg715,
  Svg716,
  Svg717,
  Svg718,
  Svg719,
  Svg720,
];

const fanPlusSelectedIcons = [Svg707, Svg714, Svg718, Svg719];

const fanIcons = [
  Svg141,
  Svg142,
  Svg143,
  Svg144,
  Svg145,
  Svg146,
  Svg147,
  Svg148,
  Svg149,
  Svg150,
  Svg151,
  Svg152,
  Svg153,
  Svg154,
  Svg155,
  Svg156,
  Svg157,
  Svg158,
  Svg159,
  Svg160,
  Svg161,
  Svg162,
  Svg163,
  Svg164,
  Svg165,
  Svg166,
  Svg167,
  Svg168,
];

const fanSelectedIcons = [Svg142];

const curtainCloseIcons = [
  Svg197,
  Svg198,
  Svg199,
  Svg200,
  Svg201,
  Svg202,
  Svg203,
  Svg204,
  Svg205,
  Svg206,
  Svg207,
  Svg208,
  Svg209,
  Svg210,
  Svg211,
  Svg212,
  Svg213,
  Svg214,
  Svg215,
  Svg216,
  Svg217,
  Svg218,
  Svg219,
  Svg220,
  Svg221,
  Svg222,
  Svg223,
  Svg224,
];

const curtainOpenIcons = [
  Svg169,
  Svg170,
  Svg171,
  Svg172,
  Svg173,
  Svg174,
  Svg175,
  Svg176,
  Svg177,
  Svg178,
  Svg179,
  Svg180,
  Svg181,
  Svg182,
  Svg183,
  Svg184,
  Svg185,
  Svg186,
  Svg187,
  Svg188,
  Svg189,
  Svg190,
  Svg191,
  Svg192,
  Svg193,
  Svg194,
  Svg195,
];

const masterOnOffIcons = [Svg673, Svg674, Svg675, Svg676];

const petsIcons = [Svg645, Svg646];

const alphabetIcon = [
  Svg617,
  Svg618,
  Svg619,
  Svg620,
  Svg621,
  Svg622,
  Svg623,
  Svg624,
  Svg625,
  Svg626,
  Svg627,
  Svg628,
  Svg629,
  Svg630,
  Svg631,
  Svg632,
  Svg633,
  Svg634,
  Svg635,
  Svg636,
  Svg637,
  Svg638,
  Svg639,
  Svg640,
  Svg641,
  Svg642,
  Svg643,
];

const numberIcons = [
  Svg589,
  Svg590,
  Svg591,
  Svg592,
  Svg593,
  Svg594,
  Svg595,
  Svg596,
  Svg597,
  Svg598,
  Svg599,
  Svg600,
  Svg601,
  Svg602,
  Svg603,
  Svg604,
  Svg605,
  Svg606,
  Svg607,
  Svg608,
];

const numberSelectedIcons = [
  Svg599,
  Svg600,
  Svg601,
  Svg602,
  Svg603,
  Svg604,
  Svg605,
  Svg606,
  Svg607,
  Svg608,
];

const hospitalityIcons = [
  Svg561,
  Svg562,
  Svg563,
  Svg564,
  Svg565,
  Svg566,
  Svg567,
  Svg568,
  Svg569,
  Svg570,
  Svg571,
];

const vehicalIcons = [
  Svg533,
  Svg534,
  Svg535,
  Svg536,
  Svg537,
  Svg538,
  Svg539,
  Svg540,
  Svg541,
];

const arrowIcons = [
  Svg477,
  Svg478,
  Svg479,
  Svg480,
  Svg481,
  Svg482,
  Svg483,
  Svg484,
  Svg485,
  Svg486,
  Svg487,
  Svg488,
  Svg489,
  Svg490,
  Svg491,
  Svg492,
  Svg493,
  Svg494,
  Svg495,
  Svg496,
  Svg497,
  Svg498,
  Svg499,
  Svg500,
  Svg501,
  Svg502,
  Svg503,
  Svg504,
  Svg505,
  Svg506,
  Svg507,
  Svg508,
  Svg509,
  Svg510,
];

const arrowSelectedIcons = [Svg487, Svg488, Svg503, Svg504];

const symbolIcons = [
  Svg421,
  Svg422,
  Svg423,
  Svg424,
  Svg425,
  Svg426,
  Svg427,
  Svg428,
  Svg429,
  Svg430,
  Svg431,
  Svg432,
  Svg433,
  Svg434,
  Svg435,
  Svg436,
  Svg437,
  Svg438,
  Svg439,
  Svg440,
  Svg441,
  Svg442,
  Svg443,
  Svg444,
  Svg445,
  Svg446,
  Svg447,
  Svg448,
  Svg449,
  Svg450,
  Svg451,
  Svg452,
  Svg453,
  Svg454,
  Svg455,
  Svg456,
  Svg457,
  Svg458,
  Svg459,
  Svg460,
  Svg461,
  Svg462,
  Svg463,
  Svg464,
  Svg465,
  Svg466,
  Svg467,
  Svg468,
  Svg469,
  Svg470,
  Svg471,
  Svg472,
];

const symbolSelectedIcons = [Svg441, Svg444, Svg445, Svg446, Svg448];

const patternIcons = [
  Svg365,
  Svg366,
  Svg367,
  Svg368,
  Svg369,
  Svg370,
  Svg371,
  Svg372,
  Svg373,
  Svg374,
  Svg375,
  Svg376,
  Svg377,
  Svg378,
  Svg379,
  Svg380,
  Svg381,
  Svg382,
  Svg383,
  Svg384,
  Svg385,
  Svg386,
  Svg387,
  Svg388,
  Svg389,
  Svg390,
  Svg391,
  Svg392,
  Svg393,
  Svg394,
  Svg395,
  Svg396,
  Svg397,
  Svg398,
  Svg399,
  Svg400,
  Svg401,
  Svg402,
  Svg403,
  Svg404,
  Svg405,
  Svg406,
  Svg407,
  Svg408,
  Svg409,
  Svg410,
  Svg411,
  Svg412,
  Svg413,
  Svg414,
  Svg415,
  Svg416,
  Svg417,
  Svg418,
  Svg419,
  Svg420,
];

const patternSelectedIcons = [Svg395, Svg396, Svg398, Svg408, Svg409];

const sceneIcons = [
  Svg309,
  Svg310,
  Svg311,
  Svg312,
  Svg313,
  Svg314,
  Svg315,
  Svg316,
  Svg317,
  Svg318,
  Svg319,
  Svg320,
  Svg321,
  Svg322,
  Svg323,
  Svg324,
  Svg325,
  Svg326,
  Svg327,
  Svg328,
  Svg329,
  Svg330,
  Svg331,
  Svg332,
  Svg333,
  Svg334,
  Svg335,
  Svg336,
  Svg338,
  Svg339,
  Svg340,
  Svg341,
  Svg342,
  Svg343,
  Svg344,
  Svg345,
  Svg346,
  Svg347,
  Svg348,
  Svg349,
  Svg350,
  Svg351,
  Svg352,
  Svg353,
  Svg354,
  Svg355,
  Svg356,
  Svg357,
  Svg358,
  Svg359,
  Svg360,
];

const sceneSelectedIcons = [Svg309, Svg339];

const accIcons = [
  Svg1,
  Svg2,
  Svg3,
  Svg4,
  Svg5,
  Svg6,
  Svg7,
  Svg8,
  Svg9,
  Svg10,
  Svg11,
  Svg12,
  Svg13,
  Svg14,
];

const accSelectedIcons = [Svg12, Svg13];

const lampIcons = [
  Svg29,
  Svg30,
  Svg31,
  Svg32,
  Svg33,
  Svg34,
  Svg35,
  Svg36,
  Svg37,
  Svg38,
  Svg39,
  Svg40,
  Svg41,
  Svg42,
  Svg43,
  Svg44,
  Svg45,
  Svg46,
  Svg47,
  Svg48,
  Svg49,
  Svg50,
  Svg51,
  Svg52,
  Svg53,
  Svg54,
  Svg55,
  Svg56,
];

const lampSelectedIcons = [Svg48];

const lightingIcons = [
  Svg57,
  Svg58,
  Svg59,
  Svg60,
  Svg61,
  Svg62,
  Svg63,
  Svg64,
  Svg65,
  Svg66,
  Svg67,
  Svg68,
  Svg69,
  Svg70,
  Svg71,
  Svg72,
  Svg73,
  Svg74,
  Svg75,
  Svg76,
  Svg77,
  Svg78,
  Svg79,
  Svg80,
  Svg81,
  Svg82,
  Svg83,
  Svg84,
  Svg85,
  Svg86,
  Svg87,
  Svg88,
  Svg89,
  Svg90,
  Svg91,
  Svg92,
  Svg93,
  Svg94,
  Svg95,
  Svg96,
  Svg97,
  Svg98,
  Svg99,
  Svg100,
  Svg101,
  Svg102,
  Svg103,
  Svg104,
  Svg105,
  Svg106,
  Svg107,
  Svg108,
  Svg109,
  Svg110,
  Svg111,
  Svg112,
  Svg113,
  Svg114,
  Svg115,
  Svg116,
  Svg117,
  Svg118,
  Svg119,
  Svg120,
  Svg121,
  Svg122,
  Svg123,
  Svg124,
  Svg125,
  Svg126,
  Svg127,
  Svg128,
  Svg129,
  Svg130,
  Svg131,
  Svg132,
  Svg133,
  Svg134,
  Svg135,
  Svg136,
];

const lightingSelectedIcons = [Svg64, Svg107, Svg112, Svg124, Svg129, Svg134];

const appliancesIcons = [
  Svg225,
  Svg226,
  Svg227,
  Svg228,
  Svg229,
  Svg230,
  Svg231,
  Svg232,
  Svg233,
  Svg234,
  Svg235,
  Svg236,
  Svg237,
  Svg238,
  Svg239,
  Svg240,
  Svg241,
  Svg242,
  Svg243,
  Svg244,
  Svg245,
  Svg246,
  Svg247,
  Svg248,
  Svg249,
  Svg250,
  Svg251,
  Svg252,
  Svg253,
  Svg254,
  Svg255,
  Svg256,
  Svg257,
  Svg258,
  Svg259,
  Svg260,
  Svg261,
  Svg262,
  Svg263,
  Svg264,
  Svg265,
  Svg266,
  Svg267,
  Svg268,
  Svg269,
  Svg270,
  Svg271,
  Svg272,
  Svg273,
  Svg274,
  Svg275,
  Svg276,
  Svg277,
  Svg278,
  Svg279,
  Svg280,
  Svg281,
  Svg282,
  Svg283,
  Svg284,
  Svg285,
];

const accIconsMapping = accIcons?.map((item, index) => {
  return {
    id: `accesories-${index + 1}`,
    icon: item,
    section: "Accesories",
    type: "switch",
  };
});

const accIconsSelectedMapping = accSelectedIcons?.map((item, index) => {
  return {
    id: `accesories-${index + 1}`,
    icon: item,
    section: "Accesories",
    type: "switchSelected",
  };
});

const lampIconMapping = lampIcons?.map((item, index) => {
  return {
    id: `lamp-${index + 1}`,
    icon: item,
    section: "Lamp",
    type: "switch",
  };
});

const lampIconSelectedMapping = lampSelectedIcons?.map((item, index) => {
  return {
    id: `lamp-${index + 1}`,
    icon: item,
    section: "Lamp",
    type: "switchSelected",
  };
});

const lightingIconMapping = lightingIcons?.map((item, index) => {
  return {
    id: `lighting-${index + 1}`,
    icon: item,
    section: "Lighting",
    type: "switch",
  };
});

const lightingSelectedIconMapping = lightingSelectedIcons?.map(
  (item, index) => {
    return {
      id: `lighting-${index + 1}`,
      icon: item,
      section: "Lighting",
      type: "switchSelected",
    };
  }
);

const applianceIconMapping = appliancesIcons?.map((item, index) => {
  return {
    id: `appliance-${index + 1}`,
    icon: item,
    section: "Appliances",
    type: "switch",
  };
});

const sceneIconMapping = sceneIcons?.map((item, index) => {
  return {
    id: `scene-${index + 1}`,
    icon: item,
    section: "Scene",
    type: "switch",
  };
});

const sceneIconSelectedMapping = sceneSelectedIcons?.map((item, index) => {
  return {
    id: `scene-${index + 1}`,
    icon: item,
    section: "Scene",
    type: "switchSelected",
  };
});

const patternIconMapping = patternIcons?.map((item, index) => {
  return {
    id: `pattern-${index + 1}`,
    icon: item,
    section: "Pattern",
    type: "switch",
  };
});

const patternSelectedIconMapping = patternSelectedIcons?.map((item, index) => {
  return {
    id: `pattern-${index + 1}`,
    icon: item,
    section: "Pattern",
    type: "switchSelected",
  };
});

const symbolIconMapping = symbolIcons?.map((item, index) => {
  return {
    id: `symbol-${index + 1}`,
    icon: item,
    section: "Symbol",
    type: "switch",
  };
});

const symbolIconSelectedMapping = symbolSelectedIcons?.map((item, index) => {
  return {
    id: `symbol-${index + 1}`,
    icon: item,
    section: "Symbol",
    type: "switchSelected",
  };
});

const arrowIconMapping = arrowIcons?.map((item, index) => {
  return {
    id: `arrow-${index + 1}`,
    icon: item,
    section: "Arrow",
    type: "switch",
  };
});

const arrowSelectedIconMapping = arrowSelectedIcons?.map((item, index) => {
  return {
    id: `arrow-${index + 1}`,
    icon: item,
    section: "Arrow",
    type: "switchSelected",
  };
});

const vehicalIconMapping = vehicalIcons?.map((item, index) => {
  return {
    id: `vehicle-${index + 1}`,
    icon: item,
    section: "Vehicle",
    type: "switch",
  };
});

const hospitalityIconMapping = hospitalityIcons?.map((item, index) => {
  return {
    id: `hospitality-${index + 1}`,
    icon: item,
    section: "Hospitality",
    type: "switch",
  };
});

const NumberIconMapping = numberIcons?.map((item, index) => {
  return {
    id: `number-${index + 1}`,
    icon: item,
    section: "Number",
    type: "switch",
  };
});

const NumberIconSelectedMapping = numberSelectedIcons?.map((item, index) => {
  return {
    id: `number-${index + 1}`,
    icon: item,
    section: "Number",
    type: "switchSelected",
  };
});

const alphabetIconMapping = alphabetIcon?.map((item, index) => {
  return {
    id: `alphabet-${index + 1}`,
    icon: item,
    section: "Alphabet",
    type: "switch",
  };
});

const petsMapping = petsIcons?.map((item, index) => {
  return {
    id: `Pets-${index + 1}`,
    icon: item,
    section: "Pets",
    type: "switch",
  };
});

const masterOnOffIconsMapping = masterOnOffIcons?.map((item, index) => {
  return {
    id: `masterOnOff-${index + 1}`,
    icon: item,
    section: "Master On Off",
    type: "master",
  };
});

const curtainOpenIconsMapping = curtainOpenIcons?.map((item, index) => {
  return {
    id: `curtainopen-${index + 1}`,
    icon: item,
    section: "Curtain Open",
    type: "curtainOpen",
  };
});

const curtainCloseIconsMapping = curtainCloseIcons?.map((item, index) => {
  return {
    id: `curtainclose-${index + 1}`,
    icon: item,
    section: "Curtain Close",
    type: "curtainClose",
  };
});

const fanIconMapping = fanIcons?.map((item, index) => {
  return {
    id: `fanIcon-${index + 1}`,
    icon: item,
    section: "Fan",
    type: "fan",
  };
});

const fanIconSelectedMapping = fanSelectedIcons?.map((item, index) => {
  return {
    id: `fanIcon-${index + 1}`,
    icon: item,
    section: "Fan",
    type: "fan",
  };
});

const fanPlusMapping = fanPlusIcons?.map((item, index) => {
  return {
    id: `fanplus-${index + 1}`,
    icon: item,
    section: "Fan Plus",
    type: "fanPlus",
  };
});

const fanPlusSelectedMapping = fanPlusSelectedIcons?.map((item, index) => {
  return {
    id: `fanplus-${index + 1}`,
    icon: item,
    section: "Fan Plus",
    type: "fanPlusSelected",
  };
});

const fanMinusIconMapping = fanMinusIcons?.map((item, index) => {
  return {
    id: `fanminus-${index + 1}`,
    icon: item,
    section: "Fan Minus",
    type: "fanMinus",
  };
});

const fanMinusIconSelectedMapping = fanSelectedMinusIcons?.map(
  (item, index) => {
    return {
      id: `fanminus-${index + 1}`,
      icon: item,
      section: "Fan Minus",
      type: "fanMinusSelected",
    };
  }
);

export const icon_mapping = {
  switch: [
    {
      name: "Accesories",
      icons: accIconsMapping,
    },
    {
      name: "Lamp",
      icons: lampIconMapping,
    },
    {
      name: "Lighting",
      icons: lightingIconMapping,
    },
    {
      name: "Appliances",
      icons: applianceIconMapping,
    },
    {
      name: "Scene",
      icons: sceneIconMapping,
    },
    {
      name: "Pattern",
      icons: patternIconMapping,
    },
    {
      name: "Symbol",
      icons: symbolIconMapping,
    },
    {
      name: "Arrow",
      icons: arrowIconMapping,
    },
    {
      name: "Vehicle",
      icons: vehicalIconMapping,
    },
    {
      name: "Hospitality",
      icons: hospitalityIconMapping,
    },
    {
      name: "Number",
      icons: NumberIconMapping,
    },
    {
      name: "Alphabet",
      icons: alphabetIconMapping,
    },
    {
      name: "Pets",
      icons: petsMapping,
    },
  ],
  switchSelected: [
    {
      name: "Accesories",
      icons: accIconsSelectedMapping,
    },
    {
      name: "Lamp",
      icons: lampIconSelectedMapping,
    },
    {
      name: "Lighting",
      icons: lightingSelectedIconMapping,
    },
    {
      name: "Scene",
      icons: sceneIconSelectedMapping,
    },
    {
      name: "Pattern",
      icons: patternSelectedIconMapping,
    },
    {
      name: "Symbol",
      icons: symbolIconSelectedMapping,
    },
    {
      name: "Arrow",
      icons: arrowSelectedIconMapping,
    },
    {
      name: "Number",
      icons: NumberIconSelectedMapping,
    },
  ],

  master: [
    {
      name: "Master On Off",
      icons: masterOnOffIconsMapping,
    },
  ],
  curtainOpen: [
    {
      name: "Curtain Open",
      icons: curtainOpenIconsMapping,
    },
  ],
  curtainClose: [
    {
      name: "Curtain Close",
      icons: curtainCloseIconsMapping,
    },
  ],
  fan: [
    {
      name: "Fan",
      icons: fanIconMapping,
    },
  ],
  fanSelected: [
    {
      name: "Fan",
      icons: fanIconSelectedMapping,
    },
  ],
  fanPlus: [
    {
      name: "Fan Plus",
      icons: fanPlusMapping,
    },
  ],
  fanMinus: [
    {
      name: "Fan Minus",
      icons: fanMinusIconMapping,
    },
  ],
  fanPlusSelected: [
    {
      name: "Fan Plus",
      icons: fanPlusSelectedMapping,
    },
  ],
  fanMinusSelected: [
    {
      name: "Fan Minus",
      icons: fanMinusIconSelectedMapping,
    },
  ],
};
